import { useState } from 'react'

export default function useDragAndDrop(onDrop: (fileList: FileList) => void) {
  const [dragActive, setDragActive] = useState(false)

  const handleDrag = function (e: any) {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true)
    } else if (e.type === 'dragleave') {
      setDragActive(false)
    }
  }

  const handleDrop = function (e: any) {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      onDrop(e.dataTransfer.files)
    }
  }

  return { handleDrag, handleDrop, dragActive }
}
